import BootstrapModal from "../../components/BootstrapModal";
import {Formik, Form, Field} from 'formik'
import TextField from "../../components/TextField";
import * as Yup from 'yup'
import PMSCheckBox from "../../components/PMSCheckBox";
import FormSelect from "../../components/FormSelect";
import {ProgressSpinner} from "primereact/progressspinner";

const QuaterForm = ({modal, quarterId, quarterName, yearNo, active, isLoading, onSubmit, onHide}) => {
    const validation = Yup.object({
        quarterName: Yup.string().required(),
        yearNo: Yup.string().required()
    })
    return (<>
        <BootstrapModal headerText="Add Quarter" size={30} visible={modal} onHide={onHide}>
            <Formik
                validationSchema={validation}
                initialValues={{quarterId: quarterId, quarterName: quarterName,yearNo: yearNo, active: active}}
                onSubmit={onSubmit}>
                {formik =>
                    (<>
                        <Form>
                            <Field type="hidden" name="quarterId"/>
                            <TextField label={'Quarter Name'} type="text" name="quarterName"/>							
                            <FormSelect id="yearNo" name="yearNo" options={[
                                {value: '', label: 'Please Select Year'},
                                {value: '2022', label: '2022'}]}/>

                            <PMSCheckBox label={'Active'} name={'active'} id={'active'}/>
                            {isLoading ? <ProgressSpinner style={ {height:30,width:30} }/> : <button type="submit" disabled={isLoading} className="btn btn-primary">{quarterId === 0 ? 'Save' : 'Update'} </button>}

                        </Form>
                    </>)}

            </Formik>
        </BootstrapModal>
    </>)
}

export default QuaterForm